import { CustomExtender } from '#/CoreFrameInterfaces';

export default class PublisherExtender implements CustomExtender {

    public AddToKnockout() {
        ko.extenders.publisher = function (target) {
            target.args = [];

            target.notifySubscribers = function () {
                target.args = arguments;
            };

            target.publish = function () {
                ko.subscribable.fn.notifySubscribers.apply(target, target.args);
            };

            return target;
        };
    }

}